import { Model } from "./model";

export class ApiObjectModel implements Model {
    _id: string = '';
    deleted: number = 0;
    name: string = '';
    type: string = 'API';
    dbName: string = '';
    collectionName: string = '';
    webpageId: string = '';
    request: any = {};
    warnings: any = {};
    selectedWebPageId: any = {};
}